<template>
  <b-modal :id="id" title="Токен агента" ok-title="Закрыть" header-bg-variant="dark" header-text-variant="light" ok-variant="dark" @ok="confirmClose" @hidden="clean">
    <b-form-group description="Скопируйте токен агента. При повторном просмотре будет сгенерирован новый токен.">
      <b-input-group>
        <b-form-input :value="token" readonly/>
        <b-input-group-append>
          <b-button variant="dark" @click="copyToken">
            <b-icon icon="clipboard"/>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'agentTokenModal',
  props: {
    id: String,
    token: String
  },
  methods: {
    copyToken () {
      if (this.token) {
        navigator.clipboard.writeText(this.token)
      }
    },
    confirmClose () {
      this.$emit('confirm', { id: this.id, success: true, reload: true })
    },
    clean () {
      this.$emit('clean')
    }
  }
}
</script>
